import { emailRegex } from "@/utils/regex";

const userInputs = (state, languagesOptions, rolesOptions = []) => {
  return [
    {
      name: "email",
      label: "customers.modal.email",
      type: "text",
      placeholder: "customers.modal.email",
      required: true,
      parameterKey: "email",
      options: [],
      value: state?.email,
      isValid: !!state?.email,
      regex: emailRegex,
      readonly: false,
    },
    {
      name: "userName",
      label: "customers.modal.userName",
      type: "text",
      placeholder: "customers.modal.userName",
      required: false,
      parameterKey: "username",
      options: [],
      value: state?.username,
      isValid: !!state.username,
      readonly: false,
      disabled: true,
    },
    {
      name: "IPaddress",
      label: "customers.modal.IPaddress",
      type: "text",
      placeholder: "customers.modal.IPaddress",
      required: false,
      parameterKey: "userIPAddress",
      options: [],
      value: state?.userIPAddress,
      isValid: true,
      readonly: false,
    },
    {
      name: "language",
      label: "customers.modal.language",
      type: "select",
      placeholder: "customers.modal.language",
      required: false,
      parameterKey: "systemLanguage",
      options: languagesOptions,
      value: state?.systemLanguage,
      isValid: true,
    },
    {
      name: "role",
      label: "customers.modal.role",
      type: "select",
      placeholder: "customers.modal.role",
      required: false,
      parameterKey: "roleId",
      options: rolesOptions,
      value:
        state?.roleId ||
        rolesOptions.find((role) => role.isClientRole === true)?.value ||
        "",
      isValid: true,
    },
    {
      name: "loginUsingEmailCode",
      label: "customers.modal.loginUsingEmailCode",
      type: "switch",
      placeholder: "customers.modal.loginUsingEmailCode",
      required: false,
      parameterKey: "isCanLoginWithCode",
      options: [],
      value: state?.isCanLoginWithCode,
      isValid: true,
    },
  ];
};

export { userInputs };
